import h1 from "../assets/pictures/about/p4.jpeg";
import s2 from "../assets/pictures/home/grid2.jpeg";
import s3 from "../assets/pictures/home/grid3.jpeg";
import s4 from "../assets/pictures/home/grid4.jpeg";
import Call from "../components/Call";
import DesktopWa from "../components/DesktopWa";
import { cls } from "../components/Utility";

export default function Heritage() {
  return (
    <>
      <img src={h1} className=" w-full xl:h-[400px] h-[500px] object-cover" />
      <p className="mt-[30px] mb-[30px] font-[Headings] text-[25px] font-semibold xl:pl-0 pl-[20px] xl:pr-0 pr-[20px] text-center tracking-wider">
        THE HERITAGE
      </p>
      <p className="mb-[50px] text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] text-center pl-[20px] pr-[20px]">
        We don’t just capture weddings,we preserve heritage, emotion, and
        tradition in their most soulful form. Every frame we create is a tribute
        to the rituals, colors, and timeless customs that make each celebration
        uniquely sacred. From the delicate glances to the grandeur of tradition,
        we craft visual heirlooms that echo through generations, honoring both
        the legacy of the past and the beauty of new beginnings.
      </p>

      <div
        className={cls(
          "flex flex-col gap-[10px] pl-[20px] pr-[20px] mb-[40px]",
          "xl:flex xl:flex-row xl:justify-center xl:gap-[10px] "
        )}
      >
        <img
          src={s2}
          className="xl:w-[370px] xl:h-[580px] w-full h-[400px] object-cover"
        />
        <img
          src={s3}
          className="xl:w-[370px] xl:h-[580px] w-full h-[400px] object-cover"
        />
        <img
          src={s4}
          className="xl:w-[370px] xl:h-[580px] w-full h-[400px] object-cover"
        />
      </div>
      <p className="mb-[50px] text-[14px] font-[description1] xl:pl-[380px] xl:pr-[380px] text-center pl-[20px] pr-[20px]">
        Crafted with creatives, every story we tell is a fusion of vision,
        emotion, and artistry. Our team of passionate storytellers,
        photographers, and editors pour heart and imagination into every detail
        from framing the perfect shot to designing cinematic narratives that
        breathe life into memories. It’s not just about capturing moments; it’s
        about crafting an experience where creativity meets meaning, and every
        frame becomes a timeless piece of art.
      </p>
      <p className="mb-[30px] font-[Headings] text-[25px] font-semibold xl:pl-0 pl-[20px] xl:pr-0 pr-[20px] text-center tracking-wider">
        CRAFTED WITH CREATIVITY
      </p>
      <div className="flex xl:justify-center xl:items-center pl-[20px] pr-[20px] xl:pl-0 xl:pr-0 mb-[40px]">
      <img
        src={s3}
        className="w-full h-[500px] xl:w-[700px] xl:h-[800px] object-cover "
      /></div>
      <div className="chat-icon">
        <DesktopWa />
      </div>
      <div className="chat-icon1">
        <Call phoneNumber="9980685056" />
      </div>
    </>
  );
}
